var exports = {
  "kL": "xdbfd91f1--894f00--container",
  "VF": "xdbfd91f1--894f00--controls--preview",
  "Ki": "xdbfd91f1--894f00--video",
  "VN": "xdbfd91f1--894f00--close",
  "VH": "xdbfd91f1--894f00--preview",
  "AG": "xdbfd91f1--894f00--hidden_preview",
  "ZH": "xdbfd91f1--894f00--play",
};

module.exports = exports;
